import React from 'react';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useReactiveVar } from '@apollo/client';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { greetingVar } from '@context';

export interface GreetingDialogProps {}

export function GreetingDialog(props: Readonly<GreetingDialogProps>) {
  const theme = useTheme();
  const { t } = useTranslation('field');
  const greeting = useReactiveVar(greetingVar);

  const handleClose = (event: React.MouseEvent, reason: string) => {
    greetingVar(null);
  };

  return (
    <Dialog scroll="body" fullScreen={false} fullWidth open={!!greeting} maxWidth="md" onClose={handleClose}>
      {greeting && (
        <Stack width="100%" height="100%" justifyContent="center" alignItems="center" spacing={2} py={10}>
          <Stack spacing={3} justifyContent="center" alignItems="center">
            <Typography variant="h3" textAlign="center">
              {t('success.Congratulations', { ns: 'authentication', firstname: greeting.firstname })} 🎉
            </Typography>
            <Typography textAlign="center">
              {t('success.Your account has been created. An email has been sent to', {
                ns: 'authentication',
              })}
            </Typography>
            <Alert icon={<theme.icons.check fontSize="inherit" />} severity="success">
              {greeting.email}
            </Alert>
            <Typography textAlign="center">
              {t('success.You should receive it soon, it will be used to validate your account.', {
                ns: 'authentication',
              })}
            </Typography>
            <Button variant="contained" onClick={handleClose}>
              {t('success.Close and login', { ns: 'authentication' })}
            </Button>
          </Stack>
        </Stack>
      )}
    </Dialog>
  );
}
